import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CurrentRouteService {
  constructor(private router: Router) {}

  getRoute() {
    const urlTree = this.router.parseUrl(this.router.url);
    const primary = urlTree.root.children['primary'];
    const segments = primary ? primary.segments.map((segment) => segment.path) : [];

    // Build the path, defaulting to '/' for the root route
    const path = '/' + segments.join('/');
    const normalizedPath = path === '/' && segments.length === 0 ? '/' : path.replace(/\/{2,}/g, '/');

    // Preserve fragments so routes like `/integrations#business-platform` still match
    const fragment = urlTree.fragment ? `#${urlTree.fragment}` : '';

    return `${normalizedPath}${fragment}`;
  }
}
